<template>
  <b-sidebar
    id="sidebar-border"
    sidebar-class="sidebar px-4 pt-3"
    right
    :shadow="true"
    width="600px"
    @hidden="onHideSidebar"
  >
    <h2>Personen einladen</h2>
    <p>Laden Sie Personen ein zu diesem Gesuch und klicken Sie auf Einladen.<br>Die Person erhält danach eine Einladung per E-Mail.</p>

    <permission-create :applicationId="applicationId"/>
    <permission-list :applicationId="applicationId" />

  </b-sidebar>
</template>

<script>
  import { mapState } from 'vuex'
  import PermissionCreate from '@/components/permission/PermissionCreate.vue'
  import PermissionList from '@/components/permission/PermissionList.vue'

  export default {
    methods: {
      onHideSidebar () {
        this.$store.commit('permission/SET_PERMISSION_APPLICATION_ID', 0)
      }
    },
    computed: {
      ...mapState({
        applicationId: state => state.permission.applicationId
      })
    },
    components: {
      PermissionCreate,
      PermissionList
    }
  }
</script>
<style lang="scss">
#sidebar-border .b-sidebar-header{
  padding: 1.5rem 0 1.5rem
}
</style>
